import clsx from "clsx";
import { NavLink } from "react-router-dom";

import type { ReactNode } from "react";

interface MobileNavigationTabsProps {
  navItems: (
    | {
        label: string;
        path: string;
        subNavItems?: { label: string; path: string }[];
      }
    | { element: ReactNode }
  )[];
  className?: string;
}

export default function MobileNavigationTabs({
  navItems,
  className,
}: MobileNavigationTabsProps) {
  return (
    <div
      className={clsx(
        "flex border-b border-b-black-200 overflow-y-auto",
        className,
      )}
    >
      {navItems.map((item) => {
        if ("element" in item) {
          return item.element;
        }
        const { subNavItems, label, path } = item;
        if (subNavItems) {
          return (
            <>
              {subNavItems.map((subNavItem) => (
                <NavLink
                  to={`${path}/${subNavItem.path}`}
                  key={label}
                  className={({ isActive }) =>
                    clsx(
                      "flex py-3 px-6 text-button-md items-center transition-[color,background] text-nowrap border-b",
                      isActive
                        ? "text-black-950 border-b-black-950"
                        : "text-black-400 border-b-transparent",
                    )
                  }
                >
                  {subNavItem.label} {label}
                </NavLink>
              ))}
            </>
          );
        }
        return (
          <NavLink
            to={path}
            key={label}
            end
            className={({ isActive }) =>
              clsx(
                "flex py-3 px-6 text-button-md items-center transition-[color,background] text-nowrap border-b",
                isActive
                  ? "text-black-950 border-b-black-950"
                  : "text-black-400 border-b-transparent",
              )
            }
          >
            {label}
          </NavLink>
        );
      })}
    </div>
  );
}
